import 'jquery-validation';
import 'jquery.inputmask';

import 'inputmask.extensions';
import 'inputmask.numeric.extensions';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'jquery-form';

$.validator.addMethod(
  "minlenghtphone",
  (value, element) => value.replace(/\D+/g, '').length > 10,
  'Укажите Ваш телефон в формате +7 (999) 999-99-99'
);


$('#popup-default').on('show.bs.modal', function (event) {
  const $button = $(event.relatedTarget); // Button that triggered the modal
  const message = $button.data('message') || $button.text(); // Extract info from data-* attributes
  const bodyContent = $($button.data('body'));
  // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
  // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
  const $modal = $(this);
  $modal.find('.modal-title').html(message.toUpperCase());
  $modal.find('.modal-body-content').html(bodyContent.html());


  $modal.find('input[type=tel]').inputmask({mask: '+7 (999) 999-9999', placeholder: ' '});

  const $form = $modal.find('form');
  $form.submit(e => e.preventDefault());
  $form.validate({
    submitHandler: form => {
      $form.ajaxSubmit({
        url: formSubmissionScript.ajaxUrl,
        type: 'post',
        dataType: 'json',
        data: {
          'title': message,
          'action': 'abcgym_form'
        },
        success: resp => {
          $form.remove();
          $modal.find('.modal-body-content').html($('#thank-you').html());
        },
        // use beforeSubmit to add your nonce to the form data before submitting.
        beforeSubmit: (arr, $form, options) => {
          arr.push({"name": "nonce", "value": formSubmissionScript.nonce});
        },
      });
    },
    rules: {
      phone: {minlenghtphone: true}
    },
    messages: {
      name: "Пожалуйста, укажите Ваше имя",
      email: {
        required: "Укажите Вашу электронную почту для связи",
        email: "Укажите Ваш email в формате name@domain.com"
      },
      phone: {
        required: "Укажите Ваш телефон, чтобы мы могли Вам перезвонить",
        phone: "Укажите Ваш телефон в формате +7 (999) 999-99-99"
      }
    }
  });
});

const $subscribeForm = $('#subscribe-form form');
$subscribeForm.find('input[type=tel]').inputmask({mask: '+7 (999) 999-9999', placeholder: ' '});
$subscribeForm.submit(e => e.preventDefault());
$subscribeForm.validate({
  submitHandler: form => {
    $subscribeForm.ajaxSubmit({
      url: formSubmissionScript.ajaxUrl,
      type: 'post',
      dataType: 'json',
      data: {
        'title': 'Подписка',
        'action': 'abcgym_form'
      },
      success: resp => {
        $subscribeForm.html('Благодарим за подписку!');
      },
      // use beforeSubmit to add your nonce to the form data before submitting.
      beforeSubmit: (arr, $form, options) => {
        arr.push({"name": "nonce", "value": formSubmissionScript.nonce});
      },
    });
  },
  rules: {
    phone: {minlenghtphone: true}
  },
  messages: {
    name: "Пожалуйста, укажите Ваше имя",
    email: {
      required: "Укажите Вашу электронную почту для связи",
      email: "Укажите Ваш email в формате name@domain.com"
    },
    phone: {
      required: "Укажите Ваш телефон, чтобы мы могли Вам перезвонить",
      phone: "Укажите Ваш телефон в формате +7 (999) 999-99-99"
    }
  }
});


// WEBPACK FOOTER //
// ./src/js/modal-content.js